export default {
  //#region ComplexityParameters
  SET_COMPLEXITY_PARAMETERS(state, items) {
    state.complexityParameters = items
  },
  ADD_COMPLEXITY_PARAMETER(state, item) {
    state.complexityParameters.unshift(item)
  },
  UPDATE_COMPLEXITY_PARAMETER(state, item) {
    const index = state.complexityParameters.findIndex((t) => t.id === item.id)
    Object.assign(state.complexityParameters[index], item)
  },
  REMOVE_COMPLEXITY_PARAMETER(state, id) {
    const index = state.complexityParameters.findIndex((t) => t.id === id)
    state.complexityParameters.splice(index, 1)
  },
  //#endregion

  //#region EnergySourceUnitConversions
  SET_ENERGY_SOURCE_CONVERSION_UNITS(state, items) {
    state.energySourceUnitConversions = items
  },
  ADD_ENERGY_SOURCE_CONVERSION_UNIT(state, item) {
    state.energySourceUnitConversions.unshift(item)
  },
  UPDATE_ENERGY_SOURCE_CONVERSION_UNIT(state, item) {
    const index = state.energySourceUnitConversions.findIndex((t) => t.id === item.id)
    Object.assign(state.energySourceUnitConversions[index], item)
  },
  REMOVE_ENERGY_SOURCE_CONVERSION_UNIT(state, id) {
    const index = state.energySourceUnitConversions.findIndex((t) => t.id === id)
    state.energySourceUnitConversions.splice(index, 1)
  },

  SET_GRID_EFFICIENCY_TEMPLATES(state, items) {
    state.gridEfficiencyTemplates = items
  },
  ADD_GRID_EFFICIENCY_TEMPLATE(state, item) {
    state.gridEfficiencyTemplates.unshift(item)
  },
  UPDATE_GRID_EFFICIENCY_TEMPLATE(state, item) {
    const index = state.gridEfficiencyTemplates.findIndex((t) => t.id === item.id)
    Object.assign(state.gridEfficiencyTemplates[index], item)
  },
  REMOVE_GRID_EFFICIENCY_TEMPLATE(state, id) {
    const index = state.gridEfficiencyTemplates.findIndex((t) => t.id === id)
    state.gridEfficiencyTemplates.splice(index, 1)
  },
  DUPLICATE_GRID_EFFICIENCY_TEMPLATE(state, id) {
    // No clue if this will work properly
    const index = state.gridEfficiencyTemplates.findIndex((t) => t.id === id)
    const obj = Object.assign({}, state.gridEfficiencyTemplates[index])
    state.gridEfficiencyTemplates.unshift(obj)
  }
}